import {calculateBill, calculatePaidTotal, financialFields, roundMoney, toAmount} from '../services/billingService.js';
export function applyStayEntry(stay, entry) {
  if (stay.status !== 'checked_in' || stay.checkedOut || stay.checkoutCompleted) throw new Error('Stay ab active nahi hai. Fresh stay kholein.');
  const type = entry.type;
  if (!['discount','payment','food_payment','food','laundry','extra'].includes(type)) throw new Error('Invalid entry type.');
  const amount = roundMoney(toAmount(entry.amount));
  if (type !== 'discount' && amount <= 0) throw new Error('Amount zero se zyada hona chahiye.');
  const next = {...stay};
  if (type === 'discount') {
    next.discountType = entry.discountType || 'flat';
    next.discountValue = toAmount(entry.discountValue ?? amount);
    next.discountAmount = next.discountType === 'percent' ? undefined : amount;
    next.gstRate = Math.max(0, toAmount(entry.gstRate ?? stay.gstRate));
    next.discountReason = entry.note || '';
    next.discountHistory = [...(stay.discountHistory || []), {...entry, addedAt: entry.addedAt}];
  } else if (type === 'payment' || type === 'food_payment') {
    const bill = calculateBill(stay);
    if (type === 'food_payment' && amount > Math.min(bill.balance, Math.max(0, bill.food - toAmount(stay.foodPaidTotal))) + .01) throw new Error('Food/current bill pending se zyada payment receive nahi kar sakte.');
    next.paidTotal = roundMoney(calculatePaidTotal(stay) + amount);
    next.payments = [...(stay.payments || []), entry];
    if (type === 'food_payment') {
      next.foodPaidTotal = roundMoney(toAmount(stay.foodPaidTotal) + amount);
      next.foodPaymentHistory = [...(stay.foodPaymentHistory || []), entry];
    }
  } else {
    next[`${type}Items`] = [...(stay[`${type}Items`] || []), entry];
    next[`${type}Total`] = roundMoney(toAmount(stay[`${type}Total`]) + amount);
  }
  return {...next, ...financialFields(next)};
}
